import React from "react";

import "./index.scss";

const BarPlotIcon = ({ isActive }) => {
  const style = isActive ? "bar-chart-plot-icon--active" : "";
  return (
    <svg
      id="Bar_chart"
      data-name="Bar chart"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      className={`bar-chart-plot-icon--container ${style}`}
    >
      <path id="Path_8585" data-name="Path 8585" d="M0,0H32V32H0Z" fill="none" />
      <g id="Group_8752" data-name="Group 8752">
        <rect id="Rectangle_267" data-name="Rectangle 267" width="1.464" height="3.651" transform="translate(20.068 17)" className="bar-chart-icon" />
        <rect
          id="Rectangle_268"
          data-name="Rectangle 268"
          width="1.464"
          height="8.783"
          transform="translate(10.468 11.868)"
          className="bar-chart-icon"
        />
        <rect
          id="Rectangle_269"
          data-name="Rectangle 269"
          width="1.464"
          height="13.174"
          transform="translate(15.268 7.477)"
          className="bar-chart-icon"
        />
      </g>
    </svg>
  );
};

export default BarPlotIcon;
